export enum CoverLetterAction {
  UPLOAD_FILE,
  ENTER_TEXT,
  SAVE_TEXT,
  CANCEL,
  DELETE,
  DOWNLOAD_FILE,
  OPEN_IN_NEW,
}

export enum CoverLetterActionsMode {
  EMPTY,
  EMPTY_OBSOLETE,
  TEXT_EDIT,
  TEXT_IDLE,
  TEXT_IDLE_OBSOLETE,
  FILE,
}
